import {MELEE_COUNTED_DAMAGE_DICE_COUNT} from "../../configs/damage";

/**
 * Выпавшие кости урона ближнего боя отряда по записи с полями diceRoll1..4
 * (combatUnits из calcMeleeCombatInput, pendingMeleeDamage). Обычный отряд
 * бросает 2 кости, селестиалы — 4 (diceRoll3/diceRoll4 есть только у них,
 * поэтому записи старых матчей не меняются)
 *
 * @param {Object} entry
 * @returns {Array<number>}
 */
export const getMeleeDiceRolls = (entry) => {
  const rolls = [entry.diceRoll1, entry.diceRoll2];
  if (entry.diceRoll3 !== undefined && entry.diceRoll4 !== undefined) {
    rolls.push(entry.diceRoll3, entry.diceRoll4);
  }
  return rolls;
};

/**
 * Индексы костей, которые идут в формулу урона: лучшие
 * MELEE_COUNTED_DAMAGE_DICE_COUNT, при равенстве — раньше по порядку. Индексы
 * возвращаются по возрастанию (в порядке костей)
 *
 * @param {Array<number>} rolls
 * @returns {Array<number>}
 */
export const getMeleeCountedDiceIndexes = (rolls) => rolls
  .map((roll, index) => ({roll, index}))
  .sort((a, b) => b.roll - a.roll || a.index - b.index)
  .slice(0, MELEE_COUNTED_DAMAGE_DICE_COUNT)
  .map(({index}) => index)
  .sort((a, b) => a - b);

/**
 * Кости, которые идут в формулу урона (calcMeleeDamage), в порядке костей.
 * Для отряда с 2 костями — сами эти кости
 *
 * @param {Object} entry — запись с diceRoll1..4
 * @returns {Array<number>} [diceRoll, diceRoll]
 */
export const getMeleeCountedDiceRolls = (entry) => {
  const rolls = getMeleeDiceRolls(entry);
  return getMeleeCountedDiceIndexes(rolls).map((index) => rolls[index]);
};
